import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import api from "../services/api";
import ProductCard from "./ProductCard";

// Customer-facing "Best Sellers" strip. Renders nothing unless the store's plan
// includes Trending AND the admin turned the storefront section on.
export default function BestSellers() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    api.get("/trending/storefront")
      .then((res) => { if (res.data?.enabled) setProducts(res.data.products || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || products.length === 0) return null;

  return (
    <section className="carousel-section" style={{ background: "#faf8f4" }}>
      <div className="section-wrap">
        <span className="section-label-tag">{t("home.mostPopular")}</span>
        <h2 className="section-title-h2" style={{ marginBottom: "32px" }}>{t("home.bestSellers")}</h2>
        <Row className="g-3">
          {products.map((p) => (
            <Col key={p._id} xs={6} sm={6} md={4} lg={3} xl={2} className="d-flex justify-content-center">
              <ProductCard product={p} productImageUrl={p.imageUrl} />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}
